import { render, staticRenderFns } from "./IconSvgGrid2.vue?vue&type=template&id=20764a7d&scoped=true&"
import script from "./IconSvgGrid2.vue?vue&type=script&lang=js&"
export * from "./IconSvgGrid2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20764a7d",
  null
  
)

export default component.exports